import { Content, Main } from "../../../components/Layout";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import Loading from "../../../components/Loading";
import TableResponsive from "../../../components/TableResponsive";

/**
 * Headcount de Convites/Ingressos desse formando, por evento — só leitura,
 * puramente informativo (não é o Financeiro Contratado). Extra já vem
 * separado por origem direto do backend: Contratado (negociado pelo gestor)
 * e Loja Virtual (comprado e pago pelo formando via Produtos).
 */
export default function TraineesInvites() {
  const { config } = useWrapper();
  const { trainee } = useOutletContext() || {};

  const [rows, setrows] = useState();
  useEffect(() => {
    (async () => {
      if (!trainee?.commercial_id) return;
      try {
        const { data } = await api.get(
          `commercial-event-invite/trainees?commercial_id=${trainee.commercial_id}`,
          config,
        );
        setrows(data?.filter(__row => __row.id === trainee.id));
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Problema ao carregar os Convites/Ingressos.");
      }
    })();
  }, [trainee?.id, trainee?.commercial_id, config]);

  // Convite e Ingresso são coisas diferentes — cada um com sua própria tabela, em vez de uma
  // tabela só de 9 colunas misturando os dois. Evento zerado (Base, Contratado e Loja Virtual
  // todos 0) não aparece — não ajuda em nada numa lista pensada pro dia do evento.
  const buildTable = prefix => ({
    head: [
      { data: "Evento" },
      { data: "Base" },
      { data: "Contratado (Extra)" },
      { data: "Loja Virtual (Extra)" },
      { data: "Total" },
    ],
    body:
      rows
        ?.filter(__row => (__row[`qtd_${prefix}`] || 0) > 0)
        ?.map(__row => ({
          data: [
            { element: __row.event_name },
            { element: __row[`base_${prefix}`] },
            { element: __row[`extra_${prefix}_contratado`] },
            { element: __row[`extra_${prefix}_loja`] },
            { element: <b>{__row[`qtd_${prefix}`]}</b> },
          ],
        })) || [],
  });

  return (
    <Row>
      <Col sm={9}>
        <Main>
          {!rows ? (
            <Content>
              <Loading />
            </Content>
          ) : (
            <Content>
              <h2 className="mini-title mb-1">Convites:</h2>
              <p className="small-label mb-2">
                Acesso à cerimônia. Base e Contratado já fazem parte do Financeiro; o comprado na Loja Virtual não.
              </p>
              <TableResponsive
                emptyMsg="Nenhum evento com Convites configurados."
                table={buildTable("invitations")}
              />
              <h2 className="mini-title mb-1 mt-4">Ingressos:</h2>
              <p className="small-label mb-2">
                Acesso à festa/baile. Base e Contratado já fazem parte do Financeiro; o comprado na Loja Virtual não.
              </p>
              <TableResponsive emptyMsg="Nenhum evento com Ingressos configurados." table={buildTable("tickets")} />
            </Content>
          )}
        </Main>
      </Col>
      <Col sm={3}>
        <TraineeSubMenu trainee={trainee} />
      </Col>
    </Row>
  );
}
